import * as React from 'react';
import { CircularProgress, makeStyles, Tooltip } from '@material-ui/core';
import { Error } from '@material-ui/icons';
import Paths from '../../../models/enums/paths';
import { Breadcrumb, Breadcrumbs } from 'kagr-ui';
import { status } from '../../../theme/colors';
import { useParams } from 'react-router-dom';
import { useSegment } from '../../../hooks/useSegment';
import * as styles from './segment-breadcrumbs.module.scss';

const breadcrumbs: Breadcrumb[] = [
  {
    title: 'Segments',
    path: Paths.Segments
  }
];

const useStyles = makeStyles({
  circularProgress: {
    display: 'block',
    '& svg.MuiCircularProgress-svg': {
      margin: 0
    }
  },
  errorIcon: {
    fontSize: 20,
    color: status.error.medium,
    '&.MuiSvgIcon-root': {
      margin: 0
    }
  }
});

const SegmentBreadcrumbs = () => {
  const overrides = useStyles();
  const { segmentId } = useParams<{ segmentId: string }>();
  const { segmentQuery } = useSegment(segmentId);

  function currentBreadcrumb() {
    if (segmentQuery.isError) {
      return (
        <Tooltip title="Segment title failed to load">
          <Error className={overrides.errorIcon} />
        </Tooltip>
      );
    }
    if (segmentQuery.isLoading) {
      return <CircularProgress size="20px" className={overrides.circularProgress} />;
    }
    if (segmentQuery.data) {
      return (
        <div className={styles.header}>
          <h1>{segmentQuery.data.name}</h1>
          {segmentQuery.isFetching && <CircularProgress size="16px" className={overrides.circularProgress} />}
        </div>
      );
    }
  }
  return <Breadcrumbs breadcrumbs={breadcrumbs} currentPage={currentBreadcrumb()} className={styles.breadcrumb} />;
};

export default SegmentBreadcrumbs;
